<template>
  <div class="offer-wrapper">
    <div class="offer section">
      <div
        class="info"
        :class="{
          'info--margin-bottom': title.length + description.length > 0
        }"
      >
        <div class="container">
          <p
            class="section-title section-title--no-padding-bottom has-text-info"
            v-if="title.length > 0"
          >
            {{ title }}
          </p>
          <div class="columns">
            <div class="column is-6 is-offset-3">
              <div class="description has-text-grey is-size-6">
                <slot name="desc" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="offer-body">
        <div class="container">
          <div class="columns">
            <div
              class="column is-5"
              :class="{
                second: mirrored,
                first: !mirrored,
                'is-6-mobile': mobileShrink,
                'is-offset-3-mobile': mobileShrink
              }"
            >
              <div class="offer-body__image is-unselectable">
                <slot name="image" />
              </div>
            </div>
            <div class="column is-7" :class="mirrored ? 'first' : 'second'">
              <div class="offer-body__content">
                <div class="content">
                  <slot />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="packages">
            <slot name="packages" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "offer",

  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    mobileShrink: Boolean,
    mirrored: Boolean
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.info--margin-bottom {
  margin-bottom: 2rem;
}

.section-title--no-padding-bottom {
  padding-bottom: 0;
}

.description {
  text-align: center;
  font-family: $family-sans-serif-wide;
  padding: 0 2rem;
}

.offer-body {
  margin-bottom: 4rem;

  &__content {
    padding: 1rem 3rem 0;
  }
}

.first {
  order: 1;
}

.second {
  order: 2;
}

li {
  padding: 0.3rem 0;
}

h3 {
  display: block;
  font-family: $family-sans-serif-wide;
  font-weight: 900;
  font-size: 1.5rem;
  padding-bottom: 1rem;
}

.packages {
  margin: 5rem 0;
}
</style>
